(function ($, Drupal, drupalSettings, once) {
  'use strict';

  function writeCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toGMTString();
    }
    document.cookie = name + '=' + value + expires + '; path=/';
  }

  function readCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length);
      }
    }
    return null;
  }

  Drupal.mytrip = {
    api: function (action, data) {

      var mytrip = this.getTrip();
      var extra = '';

      switch (action) {
        case 'add':
        case 'addMultiple':
        case 'load':
        case 'remove':
        case 'removeMultiple':
          if (!mytrip) {
            return false;
          }
          extra = mytrip.trip_id + '/' + mytrip.trip_key;
      }

      var apiurl = '/mytrip_api/' + action;
      if (extra) { apiurl += '/' + extra; }
      if (data) { apiurl += '/' + data; }

      return $.getJSON(apiurl);
    },
    updateMegaMenu: function () {
      if (this.checkTrip()) {
        var mytrip = this.getTrip();
        $('#block-megamenuformytrip .outer-wrapper ul.menu').remove();
        if (typeof mytrip.stops !== 'undefined' && mytrip.stops.length > 0) {
          var menu = $('<ul class="menu"></ul>');
          var link = $('<li class="nav-top-level"><a href="/my-trip">See all of Your Trip</a></li>');
          for (var i = mytrip.stops.length - 1; i >= 0; i--) {
            menu.append('<li><a href="/node/' + mytrip.stops[i].id + '">' + mytrip.stops[i].title + '</a></li>');
          }
          $('li', menu).slice(9).remove();
          menu.append(link);
          menu.prependTo('#block-megamenuformytrip .outer-wrapper');
        }
      }
      this.updateCounter();
    },
    updateCounter: function () {
      if (this.checkTrip()) {
        var mytrip = this.getTrip();
        if (mytrip.stops.length > 0) {
          $('.my-trip-count').html(mytrip.stops.length);
          $('body').removeClass('mytrip-empty').addClass('mytrip-notempty');
        }
        else {
          $('.my-trip-count').html('0');
          $('body').removeClass('mytrip-notempty').addClass('mytrip-empty');
        }
      }
      else {
        $('.my-trip-count').html('0');
        $('body').removeClass('mytrip-notempty').addClass('mytrip-empty');
      }
    },
    updateTrip: function () {
      if (this.checkTrip()) {
        var req = this.api('load');
        if (req) {
          req.done(function (data) {
            if (data.result !== 'badkey' && data.result !== false) {
              Drupal.mytrip.saveTrip(data.trip);
            }
            else {
              Drupal.mytrip.saveRemoteTrip();
            }
          });
        }
      }
    },
    setLink: function (id, action) {
      if (typeof action == 'undefined') {
        action = Drupal.mytrip.inTrip(id) === true ? 'remove' : 'add';
      }
      if (action === 'add') {
        $('button.mytrip[data-entity-id=' + id + ']')
          .removeClass('mytrip-remove')
          .addClass('mytrip-add');
      }
      else if (action === 'remove') {
        $('button.mytrip[data-entity-id=' + id + ']')
          .removeClass('mytrip-add')
          .addClass('mytrip-remove');
      }
    },
    toggle: function (id) {
      if (this.checkTrip()) {
        if (this.inTrip(id)) {
          // Remove Item.
          this.remove(id);
        }
        else {
          // Add Item.
          this.add(id);
        }
      }
      else {
        // no saved trip.
        this.newTrip(function (data) {
          Drupal.mytrip.add(id);
        });
      }
    },
    add: function (items) {
      if (items.constructor === Number || items.constructor === String) {
        items = [items.toString()];
      }
      if (this.checkTrip()) {
        $('html').trigger('mytripBeforeAdd', items);
        var req;
        req = this.api('addMultiple', JSON.stringify(items));
        req.done(function (data) {
          if (data.result === true) {
            var matched = data.trip.stops.filter(function (stop) {
              if (items.indexOf(stop.id.toString()) !== -1) {
                return true;
              }
            });
            if (matched.length > 0) {
              $('html').trigger('mytripAdded', [items, matched]);
            }
            // Drupal.mytrip.saveTrip(data.trip);
            $.when(Drupal.mytrip.saveTrip(data.trip)).then(function (data, textStatus, jqXHR) {
              if (window.location.pathname === '/my-trip') {
                location.reload();
              }
            });
          }
          else {
            $('html').trigger('mytripAddFailed', items);
          }
        });
        req.fail(function (data) {
          $('html').trigger('mytripAddFailed', items);
        });
      }
      else {
        this.newTrip(function (data) {
          Drupal.mytrip.add(items);
        });
      }
    },
    remove: function (items) {
      if (items.constructor === Number || items.constructor === String) {
        items = [items.toString()];
      }
      if (this.checkTrip()) {
        $('html').trigger('mytripBeforeRemove', items);
        var mytrip = this.getTrip();
        var req;
        req = this.api('removeMultiple', JSON.stringify(items));
        req.done(function (data) {
          if (data.result === true) {
            var matched = mytrip.stops.filter(function (stop) {
              if (items.indexOf(stop.id.toString()) !== -1) {
                return true;
              }
            });
            if (matched.length > 0) {
              $('html').trigger('mytripRemoved', [items, matched]);

              if (window.location.pathname === '/my-trip') {
                // Removed while on mytrip page, remove from the page.
                Drupal.behaviors.myTripMap.removeFromMytrip(matched[0].id);
              }
            }
            Drupal.mytrip.saveTrip(data.trip);
          }
          else {
            $('html').trigger('mytripRemoveFailed', items);
          }
        });
        req.fail(function (data) {
          $('html').trigger('mytripRemoveFailed', items);
        });
      }
    },
    newTrip: function (callback) {
      var req;
      req = this.api('create');
      req.done(function (data) {
        // create cookies.
        writeCookie('trip_id', data.result.trip_id, 7);
        writeCookie('trip_key', data.result.trip_key, 7);

        Drupal.mytrip.saveTrip(data.trip);
        if (typeof callback === 'function') {
          callback.call(data);
        }
      });
    },
    saveRemoteTrip: function () {
      // We have a local trip but seem t have lost it in the remote database.
      var myoldtrip = this.getTrip();
      var stop_ids = myoldtrip.stops.map(function (o) { return o.id; });
      this.newTrip(function (data) {
        Drupal.mytrip.add(stop_ids);
      });
    },
    inTrip: function (id) {
      // Check if an entity is in our local trip.
      if (this.checkTrip()) {
        var mytrip = this.getTrip();
        if (typeof mytrip.stops !== 'undefined' && mytrip.stops.filter(function (e) { return e.id === id; }).length > 0) {
          return true;
        }
        else {
          return false;
        }
      }
      else {
        return false;
      }
    },
    checkTrip: function () {
      // Check if we have a local trip saved.
      if (localStorage.getItem('mytrip_data') !== null) {
        var mytrip = JSON.parse(localStorage.getItem('mytrip_data'));
        if (typeof mytrip.trip_id === 'string' && typeof mytrip.trip_key === 'string') {
          return true;
        }
      }
      return false;
    },
    getTrip: function () {
      // Get local trip.
      if (this.checkTrip()) {
        // Check age and load from server if older than xx minutes.
        var mytrip_data = localStorage.getItem('mytrip_data');
        var mytrip = JSON.parse(mytrip_data);
        return mytrip;
      }
      else {
        return false;
      }
    },
    saveTrip: function (mytrip) {
      mytrip = $.extend(mytrip, {updated: Math.floor(Date.now() / 1000)});
      // Saves locally.
      writeCookie('trip_id', mytrip.trip_id, 7);
      writeCookie('trip_key', mytrip.trip_key, 7);
      localStorage.setItem('mytrip_data', JSON.stringify(mytrip));
      Drupal.mytrip.updateMegaMenu();
    },
    init: function () {
      if (this.checkTrip()) {
        // see if we should update  our trip.
        var mytrip = this.getTrip();
        var age = Math.floor(Date.now() / 1000) - mytrip.updated;
        // update if older than 1 hour.
        if ((age / 60 / 60) > 1 || isNaN(age)) {
          this.updateTrip();
        }
      }
      else {
        $('body').addClass('mytrip-empty');
        var trip_id = readCookie('trip_id');
        var trip_key = readCookie('trip_key');
        if (trip_id && trip_key && (trip_id !== 'undefined' || trip_key !== 'undefined')) {
          var req = this.api('load');
          if (req) {
            req.done(function (data) {
              if (data.result !== 'badkey' && data.result !== false) {
                Drupal.mytrip.saveTrip(data.trip);
                Drupal.mytrip.init();
              }
              else {
                writeCookie('trip_id', '', -1);
                writeCookie('trip_key', '', -1);
              }
            });
          }
        }
      }

      Drupal.mytrip.updateMegaMenu();
    }
  };
  Drupal.behaviors.myTripLinks = {
    attach: function () {
      window.addEventListener('acquiaLiftContentAvailable', function (e) {
        $(once('mytrip-link-processed', 'button.mytrip')).each(function () {
          Drupal.mytrip.setLink($(this).data('entityId'));
          // Set click event.
          $(this).on('click', function (e) {
            Drupal.mytrip.toggle($(this).data('entityId'), $(this).data('entityTitle'));
            e.preventDefault();
            e.stopPropagation();
          });
        });
      });

      $(once('mytrip-link-processed', 'button.mytrip')).each(function () {
        Drupal.mytrip.setLink($(this).data('entityId'));
        // Set click event.
        $(this).on('click', function (e) {
          Drupal.mytrip.toggle($(this).data('entityId'), $(this).data('entityTitle'));
          e.preventDefault();
          e.stopPropagation();
        });
      });

      $(once('mytrip-link-add', 'html')).on('mytripBeforeAdd', function (e, items) {
        if (items.constructor === Number || items.constructor === String) {
          items = [items.toString()];
        }
        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          Drupal.mytrip.setLink(item, 'remove');
        }
      });
      $(once('mytrip-link-add-fail', 'html')).on('mytripAddFailed', function (e, items) {
        if (items.constructor === Number || items.constructor === String) {
          items = [items.toString()];
        }
        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          Drupal.mytrip.setLink(item, 'remove');
        }
      });

      $(once('mytrip-link-remove', 'html')).on('mytripBeforeRemove', function (e, items) {
        if (items.constructor === Number || items.constructor === String) {
          items = [items.toString()];
        }
        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          Drupal.mytrip.setLink(item, 'add');
        }
      });
      $(once('mytrip-link-remove-fail', 'html')).on('mytripRemoveFailed', function (e, items) {
        if (items.constructor === Number || items.constructor === String) {
          items = [items.toString()];
        }
        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          Drupal.mytrip.setLink(item, 'add');
        }
      });

    }
  };


  Drupal.behaviors.myTripFilter = {
    attach: function () {
      var v = $('.view-id-mytrip, .view-id-sharedtrip');
      var partners = v.filter('.view-display-id-partners');

      if (partners.find('.map-listing').length < 1) {
        return;
      }

      var selected = partners.filter(':not(.mytrip-filter-processed)');
      if (selected.length) {
        selected.addClass('mytrip-filter-processed').each(function () {

          var listings = $(this).find('.map-listing');

          var list = $('<div class="view-list"></div>').prependTo($(this));
          $('.view-content', this).appendTo(list);

          var filter = $('<div class="view-mytrip-filter"></div>').prependTo($(list));
          $('<h2>Itinerary Stops</h2>').appendTo(filter);
          var wrapper = $('<div class="pselect-wrapper"></div>').appendTo(filter);
          $('<a href="#" class="pselect-display-value" data-default-value="All">All</a>').appendTo(wrapper);
          var opts = $('<div class="pselect-select-options"></div>').appendTo(wrapper);
          $('<a href="#" class="pselect-item" data-filter-value="">All</a>').appendTo(opts);
          $.each(drupalSettings.mytripFilters, function (id, name) {
            if (!listings.filter('.' + id).length) {
              return true;
            }
            $('<a href="#" class="pselect-item" data-filter-value="' + id + '">' + name + '</a>').appendTo(opts);
          });

          filter.pSelect({
            onChange: function (option) {
              var listings = null;

              var v = $('.view-id-mytrip, .view-id-sharedtrip');
              var partners = v.filter('.view-display-id-partners');

              if (option.data('filterValue')) {
                partners.find('.map-listing').removeClass('selected').not('.' + option.data('filterValue')).addClass('hidden').fadeOut();
                listings = partners.find('.map-listing').filter('.' + option.data('filterValue'));
              }
              else {
                listings = partners.find('.map-listing');
              }
              listings.removeClass('hidden').fadeIn();

              Drupal.behaviors.myTripMap.setMarkers(true);

            }
          });

        });
      }
    }
  };

  Drupal.mytrip.init();

  Drupal.behaviors.myTripPrint = {
    attach: function () {
      var page = window.location.href;
      if (page.includes('my-trip-print')) {
        window.print();
      }
    }
  };

  $(once('ga-mytrip-add', 'html')).on('mytripAdded', function (e, items, stops) {
    var lookup = {};
    var i;

    for (i = 0; i < stops.length; i++) {
      lookup[stops[i].id] = stops[i];
    }

    if (typeof dataLayer !== 'undefined') {
      for (i = 0; i < items.length; i++) {
        var item = items[i];

        // *disable-eslint*

        /* eslint-disable */
        dataLayer.push({
          eventCategory: 'my trip',
          eventAction: 'add to trip',
          eventLabel: lookup[item].title,
          eventvalue: '',
          event: 'eventClick'
        });
        // *enable-eslint*

        /* eslint-enable */
      }
    }
  });

  $(once('ga-mytrip-remove', 'html')).on('mytripRemoved', function (e, items, stops) {
    var lookup = {};
    var i;

    for (i = 0; i < stops.length; i++) {
      lookup[stops[i].id] = stops[i];
    }
    if (typeof dataLayer !== 'undefined') {
      for (i = 0; i < items.length; i++) {
        var item = items[i];

        // *disable-eslint*

        /* eslint-disable */
        dataLayer.push({
          eventCategory: 'my trip',
          eventAction: 'remove from trip',
          eventLabel: lookup[item].title,
          eventvalue: '',
          event: 'eventClick'
        });

        // *enable-eslint*

        /* eslint-enable */
      }
    }
  });

})(jQuery, Drupal, drupalSettings, once); // eslint-disable-line no-undef
